import React, { useEffect, useState } from 'react'
import { AnimatedText } from '../BetButtonsStyles'
import { ButtonsContent } from './ButtonsContent'

export const HandleButtonContent = (
  state: number,
  stake: string,
  currency: string,
  toFix: number,
) => {
  const [undoText, setUndoText] = useState<string>('Undo')
  const [dealText, setDealText] = useState<string>('Deal')
  const handleBtnContent = (st: number) => {
    switch (st) {
      case 4:
        setDealText('Raise')
        setUndoText('Fold')
        break
      case 5:
      case 6:
      case 11:
        setDealText('Deal')
        setUndoText('Undo')
        break
      case 8:
        setDealText('Bet')
        setUndoText('Check')
        break
      case 14:
        setDealText('Bet')
        setUndoText('Check')
        break
      case 15:
        setDealText('Bet')
        setUndoText('Check')
        break
      default:
        setDealText('Deal')
        setUndoText('Undo')
        break
    }
  }
  useEffect(() => {
    handleBtnContent(state)
  }, [state])

  const { UNDO_TEXT, DEAL_TEXT } = ButtonsContent(stake, currency, toFix)

  const UNDO = UNDO_TEXT.map((item, id) => (
    <AnimatedText fadeIn={undoText === item.name} key={id}>
      {item.content}
    </AnimatedText>
  ))
  const DEAL = DEAL_TEXT.map((item, id) => (
    <AnimatedText fadeIn={dealText === item.name} key={id}>
      {item.content}
    </AnimatedText>
  ))

  return { UNDO, DEAL }
}
